module.exports = __webpack_public_path__ + "static/media/Digital_Glyph_Green.59411e9e.png";